import "./Products.style.css";

// Components
import NavigationBar from "../../Components/NavigationBar";
import SideBar from "../../Components/SideBar";
import PaginationAdvanced from '../../Components/PaginationAdvanced';

// Function
import formatRupiah from "../../Function/formatRupiah";

// React Bootstrap Icons
import { PencilFill, PlusLg, Search, TrashFill } from "react-bootstrap-icons";

// React Bootstrap
import { Button, InputGroup, Form, Card, ListGroup, Modal, Spinner, Placeholder } from "react-bootstrap";

// React
import { useEffect, useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

// Sweet Alert 2
import Swal from "sweetalert2";

const PageProducts = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [alertMessage, setAlertMessage] = useState({});

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [productData, setProductData] = useState([]);
    const [productSearch, setProductSearch] = useState("");
    const [productPage, setProductPage] = useState(1);

    const [productName, setProductName] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [productPrice, setProductPrice] = useState(null);
    const [productStock, setProductStock] = useState(null);
    const [productUnits, setProductUnits] = useState("");
    const [productImage, setProductImage] = useState(null);

    const [createProductShow, setCreateProductShow] = useState(false);
    const handleCreateProductShow = (status) => {
        setCreateProductShow(status);
        setAlertMessage({});

        setProductName("");
        setProductDescription("");
        setProductPrice(null);
        setProductStock(null);
        setProductUnits("");
        setProductImage(null);
        return 1;
    }

    const [updateProductData, setUpdateProductData] = useState({});
    const [updateProductShow, setUpdateProductShow] = useState(false);
    const handleUpdateProductShow = (status, data) => {
        setUpdateProductShow(status);
        setAlertMessage({});
        setUpdateProductData(data);

        setProductName("");
        setProductDescription("");
        setProductPrice(null);
        setProductStock(null);
        setProductUnits("");
        setProductImage(null);
        return 1;
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/user`).then(() => {}).catch(() => navigate("/"));

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/product/show`).then((res) => {
                setProductData(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setProductData(err.response.data);
                else setProductData({"message": "Internal Server Error"});
            })
            
            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }

        fetchData();
    }, [navigate, accessToken]);

    const handleSearchProducts = async (searchPage = 1) => {
        if (isLoading) return 1;

        setIsLoading(true);
        setProductPage(searchPage);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/product/show?search=${productSearch}&page=${searchPage}`).then((res) => {
            setProductData(res.data.data);

            setIsLoading(false);
        }).catch((err) => {
            setIsLoading(false);

            if (err.status === 404) setProductData(err.response.data);
            else setProductData({"message": "Internal Server Error"});
        })
        return 1;
    }

    const handleCreateProduct = async (e) => {
        e.preventDefault();

        if (isLoading) return 1;

        const errors = {};

        if (productName === "" || productName?.length === 0 || productName === null || productName === undefined) {
            errors.name = "Product name is required!";
        }
        
        if (productPrice === "" || productPrice?.length === 0 || productPrice === null || productPrice === undefined) {
            errors.price = "Product price is required!";
        } else if (productPrice < 0) {
            errors.price = "Product price must be greater than 0!";
        }
        
        if (productStock === "" || productStock?.length === 0 || productStock === null || productStock === undefined) {
            errors.stock = "Product stock is required!";
        } else if (productStock < 0) {
            errors.stock = "Product stock must be greater than 0!";
        }
        
        if (productUnits === "" || productUnits?.length === 0 || productUnits === null || productUnits === undefined) {
            errors.uom = "Product measurement unit is required!";
        } else if (productUnits !== "sheets" && productUnits !== "pieces" && productUnits !== "pack") {
            errors.uom = "Product measurement unit must be sheets, pieces, or pack!";
        }
        
        if (productImage === "" || productImage?.length === 0 || productImage === null || productImage === undefined) {
            errors.image = "Product image is required!";
        } else if (!productImage.type.includes("image")) {
            errors.image = "Product image must be an image!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setIsLoading(true);

        const formData = new FormData();
        formData.append("name", productName);
        if (productDescription) formData.append("description", productDescription);
        formData.append("price", productPrice);
        formData.append("stock", productStock);
        formData.append("uom", productUnits);
        formData.append("image", productImage);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/product/store`, formData).then((res) => {
            setIsLoading(false);

            handleCreateProductShow(false);
            handleSearchProducts(productPage);
            
            return Swal.fire({
                title: "Success!",
                text: res.data.message,
                icon: "success"
            });
        }).catch((err) => {
            setIsLoading(false);

            if (err?.response?.status === 422) {
                return setAlertMessage(err?.response?.data?.errors);
            } else {
                console.error(err);
                handleCreateProductShow(false);

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    const handleUpdateProduct = async (e) => {
        e.preventDefault();

        if (isLoading) return 1;

        const errors = {};
        
        if (productPrice && productPrice < 0) {
            errors.price = "Product price must be greater than 0!";
        }
        
        if (productStock && productStock < 0) {
            errors.stock = "Product stock must be greater than 0!";
        }
        
        if (productUnits && productUnits !== "sheets" && productUnits !== "pieces" && productUnits !== "pack") {
            errors.uom = "Product measurement unit must be sheets, pieces, or pack!";
        }
        
        if (productImage && !productImage.type.includes("image")) {
            errors.image = "Product image must be an image!";
        }

        if (Object.keys(errors).length > 0) {
            return setAlertMessage(errors);
        }

        setAlertMessage({});
        setIsLoading(true);

        const formData = new FormData();
        if (productName) formData.append("name", productName);
        formData.append("description", productDescription);
        if (productPrice) formData.append("price", productPrice);
        if (productStock) formData.append("stock", productStock);
        if (productUnits) formData.append("uom", productUnits);
        if (productImage) formData.append("image", productImage);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.post(`${process.env.REACT_APP_API_URL}/api/product/update/${updateProductData?.id}`, formData).then((res) => {
            setIsLoading(false);

            handleUpdateProductShow(false);
            handleSearchProducts(productPage);
            
            return Swal.fire({
                title: "Success!",
                text: res.data.message,
                icon: "success"
            });
        }).catch((err) => {
            setIsLoading(false);

            if (err?.response?.status === 422) {
                return setAlertMessage(err?.response?.data?.errors);
            } else {
                console.error(err);
                handleUpdateProductShow(false);

                return Swal.fire({
                    title: "Oops!",
                    text: "Internal server error",
                    icon: "error"
                });
            }
        })
        return 1;
    }

    const handleDeleteProduct = (data) => {
        if (isLoading) return 1;

        Swal.fire({
            title: "Delete Product",
            text: `Are you sure you want to delete '${data?.name}' product?`,
            icon: "question",
            showCancelButton: true
        }).then(async (res) => {
            if (res.isConfirmed) {
                setIsLoading(true);

                axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                axios.defaults.headers.common['Accept'] = `application/json`;
                await axios.delete(`${process.env.REACT_APP_API_URL}/api/product/destroy/${data?.id}`).then((res) => {
                    setIsLoading(false);
                    handleSearchProducts(productPage);
                    
                    return Swal.fire({
                        title: "Success!",
                        text: res.data.message,
                        icon: "success"
                    });
                }).catch((err) => {
                    setIsLoading(false);

                    if (err?.response?.status === 404) {
                        return Swal.fire({
                            title: "Oops!",
                            text: err?.response?.data?.message,
                            icon: "error"
                        });
                    } else {
                        console.error(err);

                        return Swal.fire({
                            title: "Oops!",
                            text: "Internal server error",
                            icon: "error"
                        });
                    }
                })
            }
        })
        return 1;
    }

    return (
        <section id="products" className="products">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <header>
                                <h4>Products</h4>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <InputGroup>
                                        <Form.Control type="text" disabled={isLoading} placeholder="Search Products" onChange={(e) => setProductSearch(e.target.value)} />
                                        <Button variant="primary" disabled={isLoading} onClick={handleSearchProducts}><Search /></Button>
                                    </InputGroup>
                                    <Button variant="success" onClick={() => handleCreateProductShow(true)}><PlusLg /></Button>
                                </div>
                            </header>
                            <main>
                                {productData?.["message"] && <h6>{productData["message"]}</h6>}

                                {productData?.["data"]?.length > 0 && productData["data"].map((item, index) => (
                                    <Card key={index}>
                                        <Card.Img variant="top" src={process.env.REACT_APP_API_URL + '/storage/products/' + item.image} />
                                        <Card.Body>
                                            <Card.Title>{item.name}</Card.Title>
                                            <Card.Text>{item.description ? item.description.slice(0, 24) + "..." : "-"}</Card.Text>
                                        </Card.Body>
                                        <ListGroup className="list-group-flush">
                                            <ListGroup.Item>{formatRupiah(item.price)}</ListGroup.Item>
                                            <ListGroup.Item>{item.stock} {item.uom}</ListGroup.Item>
                                            <ListGroup.Item>{item.sku}</ListGroup.Item>
                                            <ListGroup.Item>{item.sold} sold</ListGroup.Item>
                                        </ListGroup>
                                        <Card.Body className="d-flex align-items-center justify-content-end gap-2">
                                            <Button variant="warning" onClick={() => handleUpdateProductShow(true, item)}>
                                                <PencilFill />
                                            </Button>
                                            <Button variant="danger" disabled={isLoading} onClick={() => handleDeleteProduct(item)}>
                                                <TrashFill />
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                ))}
                            </main>
                            {productData?.last_page > 1 && (
                                <footer>
                                    <PaginationAdvanced arrayData={productData} handleSearchData={handleSearchProducts} />
                                </footer>
                            )}
                        </>
                    ) : (
                        <>
                            <header>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "8px",  width: "100px", height: "24px" }} />
                                </Placeholder>
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "250px", height: "32px" }} />
                                    </Placeholder>
                                    <Placeholder animation="glow">
                                        <Placeholder style={{ borderRadius: "8px",  width: "32px", height: "32px" }} />
                                    </Placeholder>
                                </div>
                            </header>
                            <main>
                                {Array.from({ length: 10 }).map((_, index) => (
                                    <Card key={index}>
                                        <Placeholder animation="glow">
                                            <Placeholder style={{ borderRadius: "4px",  width: "100%", height: "auto", aspectRatio: "1 / 1" }} />
                                        </Placeholder>
                                        <Card.Body>
                                            <Placeholder as={Card.Title} animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "80%", height: "24px" }} />
                                            </Placeholder>
                                            <Placeholder as={Card.Text} animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "100%", height: "16px" }} />
                                            </Placeholder>
                                        </Card.Body>
                                        <ListGroup className="list-group-flush">
                                            <Placeholder as={ListGroup.Item} animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "50%", height: "16px" }} />
                                            </Placeholder>
                                            <Placeholder as={ListGroup.Item} animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "50%", height: "16px" }} />
                                            </Placeholder>
                                            <Placeholder as={ListGroup.Item} animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "50%", height: "16px" }} />
                                            </Placeholder>
                                            <Placeholder as={ListGroup.Item} animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "50%", height: "16px" }} />
                                            </Placeholder>
                                        </ListGroup>
                                        <Card.Body className="d-flex align-items-center justify-content-end gap-2">
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "42px", height: "38px" }} />
                                            </Placeholder>
                                            <Placeholder animation="glow">
                                                <Placeholder style={{ borderRadius: "4px",  width: "42px", height: "38px" }} />
                                            </Placeholder>
                                        </Card.Body>
                                    </Card>
                                ))};
                            </main>
                            <footer>
                                <Placeholder animation="glow">
                                    <Placeholder style={{ borderRadius: "4px",  width: "150px", height: "38px" }} />
                                </Placeholder>
                            </footer>
                        </>
                    )}
                </div>
            </div>

            {/* Modal Create Product */}
            <Modal show={createProductShow} onHide={() => handleCreateProductShow(false)}>
                <form action="POST" onSubmit={handleCreateProduct}>
                    <Modal.Header closeButton>
                        <Modal.Title>Create Product</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter product name" onChange={(e) => setProductName(e.target.value)} disabled={isLoading} />
                            {alertMessage?.name && <Form.Text className="text-danger">{alertMessage.name}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control type="text" placeholder="Enter product description" onChange={(e) => setProductDescription(e.target.value)} disabled={isLoading} />
                            {alertMessage?.description && <Form.Text className="text-danger">{alertMessage.description}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Price <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="number" placeholder="Enter product price" onChange={(e) => setProductPrice(e.target.value)} disabled={isLoading} />
                            {alertMessage?.price && <Form.Text className="text-danger">{alertMessage.price}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Stock <span className="text-danger">*</span></Form.Label>
                            <div className="stock-wrapper">
                                <Form.Control type="number" placeholder="Enter product stock" onChange={(e) => setProductStock(e.target.value)} disabled={isLoading} />
                                <Form.Select onChange={(e) => setProductUnits(e.target.value)} disabled={isLoading}>
                                    <option value="">-</option>
                                    <option value="sheets">Sheets</option>
                                    <option value="pieces">Pieces</option>
                                    <option value="pack">Pack</option>
                                </Form.Select>
                            </div>
                            {alertMessage?.stock && <><Form.Text className="text-danger">{alertMessage.stock}</Form.Text><br /></>}
                            {alertMessage?.uom && <Form.Text className="text-danger">{alertMessage.uom}</Form.Text>}
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Image <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="file" accept="image/*" placeholder="Enter product image" onChange={(e) => setProductImage(e.target.files[0])} disabled={isLoading} />
                            {alertMessage?.image && <Form.Text className="text-danger">{alertMessage.image}</Form.Text>}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading && <Spinner size="sm" className="me-2" />}
                            Submit
                        </Button>
                        <Button variant="secondary" onClick={() => handleCreateProductShow(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            {/* End of Modal Create Product */}

            {/* Modal Update Product */}
            <Modal show={updateProductShow} onHide={() => handleUpdateProductShow(false, {})}>
                <form action="POST" onSubmit={handleUpdateProduct}>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Product</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter product name" defaultValue={updateProductData?.name} onChange={(e) => setProductName(e.target.value)} disabled={isLoading} />
                            {alertMessage?.name && <Form.Text className="text-danger">{alertMessage.name}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control type="text" placeholder="Enter product description" defaultValue={updateProductData?.description} onChange={(e) => setProductDescription(e.target.value)} disabled={isLoading} />
                            {alertMessage?.description && <Form.Text className="text-danger">{alertMessage.description}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Price <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="number" placeholder="Enter product price" defaultValue={updateProductData?.price} onChange={(e) => setProductPrice(e.target.value)} disabled={isLoading} />
                            {alertMessage?.price && <Form.Text className="text-danger">{alertMessage.price}</Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Stock <span className="text-danger">*</span></Form.Label>
                            <div className="stock-wrapper">
                                <Form.Control type="number" placeholder="Enter product stock" defaultValue={updateProductData?.stock} onChange={(e) => setProductStock(e.target.value)} disabled={isLoading} />
                                <Form.Select defaultValue={updateProductData?.uom} onChange={(e) => setProductUnits(e.target.value)} disabled={isLoading}>
                                    <option value="">-</option>
                                    <option value="sheets">Sheets</option>
                                    <option value="pieces">Pieces</option>
                                    <option value="pack">Pack</option>
                                </Form.Select>
                            </div>
                            {alertMessage?.stock && <><Form.Text className="text-danger">{alertMessage.stock}</Form.Text><br /></>}
                            {alertMessage?.uom && <Form.Text className="text-danger">{alertMessage.uom}</Form.Text>}
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Image <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="file" accept="image/*" placeholder="Enter product image" onChange={(e) => setProductImage(e.target.files[0])} disabled={isLoading} />
                            {alertMessage?.image && <Form.Text className="text-danger">{alertMessage.image}</Form.Text>}
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                            {isLoading && <Spinner size="sm" className="me-2" />}
                            Submit
                        </Button>
                        <Button variant="secondary" onClick={() => handleUpdateProductShow(false, {})}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
            {/* End of Modal Update Product */}
        </section>
    )
}

export default PageProducts